if (!customElements.get("custom-select")) {
  class CustomSelect extends HTMLElement {
    constructor() {
      super();
    }

    updateLabelText(selectedOption) {
      if (!this.parent) return;

      const selectedValueText = this.parent.querySelector(
        "[data-selected-value-for-option]"
      );
      if (!selectedValueText) return;

      selectedValueText.textContent = selectedOption;
    }

    updateNativeSelectValue(option) {
      if (!this.parent) return;

      const selectElement = this.parent.querySelector("select");
      if (!selectElement) return console.log("no select");

      const targetOption = selectElement.querySelector(
        `[data-value-handle="${option.getAttribute("data-option-handle")}"]`
      );
      if (!targetOption) return console.log("no option");

      selectElement.value = targetOption.value;

      selectElement.dispatchEvent(new Event("change"));
    }

    connectedCallback() {
      this.selectBtn = this.querySelector(".select-btn");
      this.options = this.querySelectorAll(".option");
      this.sBtn_text = this.querySelector(".sBtn-text");
      this.image = this.querySelector("[js-select-img]");

      this.parent = this.closest(".js-enabled[data-product-option]");

      this.selectBtn.addEventListener("click", (event) => {
        event.preventDefault();
        this.classList.toggle("active");
      });

      this.options.forEach((option) => {
        option.addEventListener("click", (event) => {
          event.stopPropagation();
          let selectedOption = option.querySelector(
            ".option-text__inner"
          ).innerText;
          this.sBtn_text.innerText = selectedOption;

          const newImage = option.querySelector("img");
          if (newImage && this.image) {
            const clonedImage = newImage.cloneNode(true);
            this.image.parentNode.replaceChild(clonedImage, this.image);
            this.image = clonedImage;
          }

          this.classList.remove("active");

          this.updateLabelText(selectedOption);
          this.updateNativeSelectValue(option.firstElementChild);
        });
      });

      this.classList.add("initialized");
    }
  }

  customElements.define("custom-select", CustomSelect);
}
